<template>
  <div class="welcome__pics composition">
    <!-- eslint-disable-next-line prettier/prettier -->
    <img
      :src="firstImg.url"
      :alt="firstImg.alt"
      class="composition__photo composition__photo--p1"
      @click="$emit('imageIndx', 0)"
    />
    <!-- eslint-disable-next-line prettier/prettier -->
    <img
      :src="secondImg.url"
      :alt="secondImg.alt"
      class="composition__photo composition__photo--p2"
      @click="$emit('imageIndx', 1)"
    />
    <!-- eslint-disable-next-line prettier/prettier -->
    <img
      :src="thirdImg.url"
      :alt="thirdImg.alt"
      class="composition__photo composition__photo--p3"
      @click="$emit('imageIndx', 2)"
    />
  </div>
</template>

<script>
export default {
  name: 'VPicsCompo',
  props: {
    firstImg: {
      type: Object,
      required: true,
    },
    secondImg: {
      type: Object,
      required: true,
    },
    thirdImg: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.composition {
  position: relative;
  min-width: 400px;
  margin-top: -250px;

  img {
    border-radius: 5px;
  }

  &__photo {
    width: 55%;
    box-shadow: 0 15px 40px rgba(#000, 0.4);
    // border-radius: 2px;
    position: absolute;
    z-index: 10;
    transition: all 0.2s;

    &--p1 {
      left: 0;
      top: -20px;
    }

    &--p2 {
      right: 0;
      top: 20px;
    }

    &--p3 {
      left: 20%;
      top: 100px;
    }

    &:hover {
      transform: scale(1.2) translate(-5px);
      box-shadow: 0 25px 40px rgba(#000, 0.5);
      z-index: 20;
    }
  }

  &:hover &__photo:not(:hover) {
    transform: scale(0.95);
  }
}

@media (max-width: 800px) {
  .composition {
    display: none;
  }
}
</style>
